import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type MswConfig } from '#apps/client-web/app/config/msw';

export class MswService {
  /* Prevent instantiation */
  private constructor() {}

  static async setup(opts: MswConfig, { logger }: LoggingContext = {}) {
    logger?.debug({ opts }, 'Setting up MSW (mock service worker)...');

    if (!opts.enabled) {
      logger?.debug('Mock API is not enabled, skipping MSW setup.');
      return;
    }

    logger?.debug('Mock API is enabled, starting MSW worker...');
    // @TODO: implement MSW worker startup
    // const { worker } = await import('packages/web/src/api/msw-browser');
    // return worker.start();

    logger?.debug('MSW setup completed.');
  }
}
